/**
 * Représente l'item scanné ou commandé.
 */
export class ReceptionHeader {
  ReceptionCreationDate_debut: Date;
  ReceptionCreationDate_fin: Date;
  IsCompleted: string;
}
